import { render } from "./ErrorWrapper.vue?vue&type=template&id=8178b716&scoped=true"
import script from "./ErrorWrapper.vue?vue&type=script&lang=js"
export * from "./ErrorWrapper.vue?vue&type=script&lang=js"

import "./ErrorWrapper.vue?vue&type=style&index=0&id=8178b716&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8178b716"]])

export default __exports__